import { TechnologicalSolutions } from "@/@types";
import { ApiClient } from "../../ApiClient"
import { GetTechnologicalSolutionsResponse } from "../schema/GetTechnologicalSolutionsResponse";
import { mapTechnologicalSolutions } from "../../mappers/technologicalSolutions/technologicalSolutionsMapper";

export const getTechnologicalSolutions = async (): Promise<TechnologicalSolutions> => {
    const client = ApiClient.getInstance();

    try {
        const response = await client.get<GetTechnologicalSolutionsResponse>(`technological-solutions/solutions`);
        return response.data ? mapTechnologicalSolutions(response.data) : [];
    } catch (error: any) {
        console.error("Error inesperado al obtener soluciones tecnológicas:", error);
        return [];
    }
};
